import { useEffect, useState } from 'react'
import {
  BsDiscord,
  BsFacebook,
  BsFileEarmarkBreak,
  BsGithub,
  BsLinkedin,
  BsSkype,
  BsSlack,
  BsSpotify,
  BsTiktok,
  BsYoutube,
} from 'react-icons/bs'
import { RiTwitterXFill } from 'react-icons/ri'
import { ContactAddressType } from '../common/ContactAddress.type'
import { InputTextType } from '../common/InputType'
import { CONTACT_FIELD_MAX_LENGTH } from '../util/contactFieldLimits'

export type ContactSiteInfo = {
  state: {
    site: string
    twitter: string
    linkedIn: string
    facebook: string
    skype: string
    discord: string
    slack: string
    github: string
    youtube: string
    tiktok: string
    spotify: string
  }
  siteInput: InputTextType
  twitterInput: InputTextType
  linkedInInput: InputTextType
  facebookInput: InputTextType
  skypeInput: InputTextType
  discordInput: InputTextType
  slackInput: InputTextType
  githubInput: InputTextType
  youtubeInput: InputTextType
  tiktokInput: InputTextType
  spotifyInput: InputTextType
}

const useContactSiteInfo = (
  contactAddress?: ContactAddressType,
): ContactSiteInfo => {
  const [site, setSite] = useState(
    contactAddress && contactAddress.site ? contactAddress.site : '',
  )
  const [twitter, setTwitter] = useState(
    contactAddress && contactAddress.twitter ? contactAddress.twitter : '',
  )
  const [linkedIn, setLinkedIn] = useState(
    contactAddress && contactAddress.linkedIn ? contactAddress.linkedIn : '',
  )
  const [facebook, setFacebook] = useState(
    contactAddress && contactAddress.facebook ? contactAddress.facebook : '',
  )
  const [skype, setSkype] = useState(
    contactAddress && contactAddress.skype ? contactAddress.skype : '',
  )
  const [discord, setDiscord] = useState(
    contactAddress && contactAddress.discord ? contactAddress.discord : '',
  )
  const [slack, setSlack] = useState(
    contactAddress && contactAddress.slack ? contactAddress.slack : '',
  )
  const [github, setGithub] = useState(
    contactAddress && contactAddress.github ? contactAddress.github : '',
  )
  const [youtube, setYoutube] = useState(
    contactAddress && contactAddress.youtube ? contactAddress.youtube : '',
  )
  const [tiktok, setTiktok] = useState(
    contactAddress && contactAddress.tiktok ? contactAddress.tiktok : '',
  )
  const [spotify, setSpotify] = useState(
    contactAddress && contactAddress.spotify ? contactAddress.spotify : '',
  )

  useEffect(() => {
    if (contactAddress?.site) {
      setSite(contactAddress?.site)
    }
  }, [contactAddress?.site])

  useEffect(() => {
    if (contactAddress?.twitter) {
      setTwitter(contactAddress?.twitter)
    }
  }, [contactAddress?.twitter])

  useEffect(() => {
    if (contactAddress?.linkedIn) {
      setLinkedIn(contactAddress?.linkedIn)
    }
  }, [contactAddress?.linkedIn])

  useEffect(() => {
    if (contactAddress?.facebook) {
      setFacebook(contactAddress?.facebook)
    }
  }, [contactAddress?.facebook])

  useEffect(() => {
    if (contactAddress?.skype) {
      setSkype(contactAddress?.skype)
    }
  }, [contactAddress?.skype])

  useEffect(() => {
    if (contactAddress?.discord) {
      setDiscord(contactAddress?.discord)
    }
  }, [contactAddress?.discord])

  useEffect(() => {
    if (contactAddress?.slack) {
      setSlack(contactAddress?.slack)
    }
  }, [contactAddress?.slack])

  useEffect(() => {
    if (contactAddress?.github) {
      setGithub(contactAddress?.github)
    }
  }, [contactAddress?.github])

  useEffect(() => {
    if (contactAddress?.youtube) {
      setYoutube(contactAddress?.youtube)
    }
  }, [contactAddress?.youtube])

  useEffect(() => {
    if (contactAddress?.tiktok) {
      setTiktok(contactAddress?.tiktok)
    }
  }, [contactAddress?.tiktok])

  useEffect(() => {
    if (contactAddress?.spotify) {
      setSpotify(contactAddress?.spotify)
    }
  }, [contactAddress?.spotify])

  const siteInput: InputTextType = {
    type: 'url',
    id: 'site',
    label: 'Webサイト',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: site,
    setState: setSite,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.site,
    icon: BsFileEarmarkBreak,
  }
  const twitterInput: InputTextType = {
    type: 'text',
    id: 'twitter',
    label: 'X(Twitter)',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: twitter,
    setState: setTwitter,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.twitter,
    icon: RiTwitterXFill,
  }
  const linkedInInput: InputTextType = {
    type: 'text',
    id: 'linkedIn',
    label: 'LinkedIn',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: linkedIn,
    setState: setLinkedIn,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.linkedIn,
    icon: BsLinkedin,
  }
  const facebookInput: InputTextType = {
    type: 'text',
    id: 'facebook',
    label: 'Facebook',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: facebook,
    setState: setFacebook,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.facebook,
    icon: BsFacebook,
  }
  const skypeInput: InputTextType = {
    type: 'text',
    id: 'skype',
    label: 'Skype',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: skype,
    setState: setSkype,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.skype,
    icon: BsSkype,
  }
  const discordInput: InputTextType = {
    type: 'text',
    id: 'discord',
    label: 'Discord',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: discord,
    setState: setDiscord,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.discord,
    icon: BsDiscord,
  }
  const slackInput: InputTextType = {
    type: 'text',
    id: 'slack',
    label: 'Slack',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: slack,
    setState: setSlack,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.slack,
    icon: BsSlack,
  }
  const githubInput: InputTextType = {
    type: 'text',
    id: 'github',
    label: 'Github',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: github,
    setState: setGithub,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.github,
    icon: BsGithub,
  }
  const youtubeInput: InputTextType = {
    type: 'text',
    id: 'youTube',
    label: 'YouTube',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: youtube,
    setState: setYoutube,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.youtube,
    icon: BsYoutube,
  }
  const tiktokInput: InputTextType = {
    type: 'text',
    id: 'tikTok',
    label: 'TikTok',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: tiktok,
    setState: setTiktok,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.tiktok,
    icon: BsTiktok,
  }
  const spotifyInput: InputTextType = {
    type: 'text',
    id: 'spotify',
    label: 'Spotify',
    placeholder: '',
    required: false,
    autoComplete: 'none',
    state: spotify,
    setState: setSpotify,
    readonly: false,
    maxLength: CONTACT_FIELD_MAX_LENGTH.spotify,
    icon: BsSpotify,
  }

  return {
    state: {
      site,
      twitter,
      linkedIn,
      facebook,
      skype,
      discord,
      slack,
      github,
      youtube,
      tiktok,
      spotify,
    },
    siteInput,
    twitterInput,
    linkedInInput,
    facebookInput,
    skypeInput,
    discordInput,
    slackInput,
    githubInput,
    youtubeInput,
    tiktokInput,
    spotifyInput,
  }
}

export default useContactSiteInfo
